<template>
  <div style="position: relative">
    <div style="position: relative">
      <FilterFields
        :fields="[
          { type: 'text', label: 'Documento', field: 'documento' },
          { type: 'text', label: 'Cliente', field: 'cliente' },
          { type: 'text', label: 'CNPJ/CPF', field: 'cnpj_cpf' },
          { type: 'text', label: 'Descrição', field: 'descricao' },
          { type: 'text', label: 'Meio Pag.', field: 'meio_pagamento' },
          {
            type: 'select',
            label: 'Status',
            field: 'status',
            options: [
              'Vencida',
              'A receber',
              'Recebida',
              'Agrupada',
              'Inativa',
              'Todos',
            ],
          },
          { type: 'date', label: 'Vencimento', field: 'data_vencimento' },
          { type: 'date', label: 'Recebimento', field: 'data_recebimento' },
          { type: 'date', label: 'Emissão', field: 'created_at' },
          { type: 'text', label: 'Banco', field: 'banco' },
          {
            type: 'select',
            label: 'Marcada',
            field: 'conta_marcada',
            options: ['Sim', 'Não'],
          },
          { type: 'text', label: 'Plano de contas', field: 'plano_de_contas' },
          { type: 'text', label: 'R$ Valor', field: 'valor' },
        ]"
      />
      <div
        class="d-flex align-items-center my-2"
        style="position: absolute; top: -7px; left: 110px; z-index: 99"
      >
        <b-dropdown
          :text="periodFilterLabel"
          split
          split-variant="secondary"
          id="menu"
          variant="primary"
          v-b-tooltip.right="''"
        >
          <b-dropdown-item
            :active="
              hasPeriodFilter && filtersStore.filterOptionSelected.id === 1
            "
            @click="
              () =>
                (filtersStore.filterOptionSelected = { id: 1, label: 'Hoje' })
            "
            >Hoje</b-dropdown-item
          >
          <b-dropdown-item
            :active="
              hasPeriodFilter && filtersStore.filterOptionSelected.id === 2
            "
            @click="
              () =>
                (filtersStore.filterOptionSelected = { id: 2, label: 'Ontem' })
            "
          >
            Ontem
          </b-dropdown-item>
          <b-dropdown-item
            :active="
              hasPeriodFilter && filtersStore.filterOptionSelected.id === 3
            "
            @click="
              () =>
                (filtersStore.filterOptionSelected = {
                  id: 3,
                  label: 'Essa semana',
                })
            "
          >
            Essa semana
          </b-dropdown-item>
          <b-dropdown-item
            :active="
              hasPeriodFilter && filtersStore.filterOptionSelected.id === 4
            "
            @click="
              () =>
                (filtersStore.filterOptionSelected = {
                  id: 4,
                  label: 'Semana passada',
                })
            "
          >
            Semana passada
          </b-dropdown-item>
          <b-dropdown-item
            :active="
              hasPeriodFilter && filtersStore.filterOptionSelected.id === 5
            "
            @click="
              () =>
                (filtersStore.filterOptionSelected = {
                  id: 5,
                  label: 'Esse mês',
                })
            "
          >
            Esse mês
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-dropdown
      id="menu"
      variant="dark"
      v-b-tooltip.right="'Mais ações'"
      v-if="actionsStore.selectedRows.length > 0"
      style="position: absolute; top: 0; left: 50px"
    >
      <template #button-content>
        <Menu :size="18" />
      </template>
      <b-dropdown-item v-b-modal.menuAcoes
        >Recebimento de contas</b-dropdown-item
      >
      <b-dropdown-item
        v-b-modal.duplicarContaReceber
        :disabled="actionsStore.selectedRows.length !== 1"
      >
        Duplicar conta
      </b-dropdown-item>
      <b-dropdown-item @click="abrirRecebimentoParcial"
        >Recebimento Parcial</b-dropdown-item
      >
      <b-dropdown-item @click="abrirAgrupamentoContas"
        >Agrupar contas</b-dropdown-item
      >
      <b-dropdown-item
        @click="
          () =>
            getRequestAdmin(() => {
              $bvModal.show('estornarContas');
            })
        "
        >Estornar Contas</b-dropdown-item
      >
      <b-dropdown-item v-b-modal.gerarCarne
        >Gerar carnê de boletos</b-dropdown-item
      >
      <b-dropdown-item v-b-modal.gerarRecibo>Gerar recibo</b-dropdown-item>
      <b-dropdown-item v-b-modal.gerarCarneLoja
        >Gerar carnê loja</b-dropdown-item
      >
      <b-dropdown-item v-b-modal.gerarCarneBoleto
        >Gerar carnê de boletos reduzido</b-dropdown-item
      >
      <b-dropdown-item v-b-modal.marcarContas
        >Marcar/Desmarcar Contas</b-dropdown-item
      >
      <b-dropdown-item v-b-modal.inativarContas
        >Inativar Contas</b-dropdown-item
      >
    </b-dropdown>

    <b-modal
      id="duplicarContaReceber"
      title="Deseja duplicar a conta a receber selecionada?"
      centered
      size="xs"
    >
      <p>{{ actionsStore.selectedRows[0]?.historico }}</p>
      <template #modal-footer="{ cancel }">
        <div>
          <b-button
            variant="primary"
            @click="duplicarConta"
            ref="duplicar_conta_receber"
            class="mr-5"
          >
            Confirmar
          </b-button>
          <b-button @click="cancel()">Cancelar</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="inativarContas"
      title="Deseja inativar as Contas selecionadas?"
      centered
      size="xs"
    >
      <p>Recurso utilizado para inativar contas.</p>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="inativarConta"
            ref="inativarConta"
            class="mr-5"
          >
            Inativar
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="marcarContas"
      title="Deseja marcar as Contas?"
      centered
      size="xs"
    >
      <p>
        Recurso utilizado para melhorar a visualização das contas selecionadas.
      </p>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="marcar"
            ref="marcarContas"
            class="mr-5"
          >
            Marcar
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="gerarRecibo" title="Recibo" centered size="xs">
      <div v-if="actionsStore.selectedRows.length <= 1" class="d-flex">
        <p>Será gerado um recibo referente a conta selecionada</p>
      </div>
      <div v-else>
        <p>Como deseja gerar os recibos das contas selecionadas?</p>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <div v-if="actionsStore.selectedRows.length <= 1">
          <b-button
            variant="primary"
            @click="gerarRecibo"
            ref="gerarRecibo"
            class="mr-5"
          >
            Gerar recibo
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
        <div v-else>
          <b-button
            variant="primary"
            @click="gerarRecibo('unificado')"
            ref="gerarReciboUnificado"
            class="mr-5"
          >
            Unificar recibos
          </b-button>
          <b-button
            variant="primary"
            @click="gerarRecibo('individual')"
            ref="gerarRecibosIndividuais"
            class="mr-5"
          >
            Gerar individuais
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="gerarCarneBoleto"
      title="Deseja gerar carnê todas as contas selecionadas?"
      centered
      size="xs"
    >
      <div class="d-flex">
        <p>
          Lembrando que será gerado o carnê somente de contas para o mesmo
          cliente.
        </p>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="gerarCarneBoletoReduzido"
            ref="gerarCarneBoleto"
            class="mr-5"
          >
            Gerar carnê
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="gerarCarne"
      title="Deseja agrupar todas as contas selecionadas?"
      centered
      size="xs"
    >
      <div class="d-flex">
        <p>
          Lembrando que será gerado o carnê somente de contas para o mesmo
          cliente.
        </p>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="gerarCarne"
            ref="gerarCarne"
            class="mr-5"
            >Gerar carnê</b-button
          >
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="gerarCarneLoja"
      title="Deseja agrupar todas as contas selecionadas?"
      centered
      size="xs"
    >
      <div class="d-flex">
        <p>
          Lembrando que será gerado o carnê somente de contas para o mesmo
          cliente.
        </p>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="gerarCarneLoja"
            ref="gerarCarneLoja"
            class="mr-5"
          >
            Gerar carnê
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="estornarContas"
      title="Deseja estornar as Contas?"
      centered
      size="xs"
    >
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="estornar"
            ref="estornar_contas"
            class="mr-5"
          >
            Estornar
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="receberParcialMassa"
      title="Recebimento parcial de contas"
      centered
      size="xl"
      v-if="recebimentoParcialItems.length > 0"
    >
      <b-form class="form">
        <div class="d-flex" style="max-height: 450px; overflow: auto">
          <b-table
            striped
            small
            hover
            :items="recebimentoParcialItems"
            :fields="recebimentoParcialTableFields"
          >
            <template #cell(vencimento_atual)="row">
              {{ formatDate(row.item.vencimento_atual) }}
            </template>
            <template #cell(valor_total)="row">
              R$ {{ numberToReal(row.item.valor_total, 2) }}
            </template>
            <template #cell(valor_parcial)="row">
              <money
                class="form-control"
                v-model="row.item.valor_parcial"
                v-bind="configMask"
              />
            </template>
            <template #cell(data_vencimento)="row">
              <b-form-datepicker
                v-model="row.item.data_vencimento"
                locale="pt-br"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
              />
            </template>
            <template #cell(saldo_restante)="row">
              <span class="font-weight-bold text-primary">
                R$ {{ numberToReal(getSaldoRestanteParcial(row.item), 2) }}
              </span>
            </template>
          </b-table>
        </div>
      </b-form>
      <template #modal-footer="{ ok, cancel }">
        <div class="d-flex">
          <b-form-group
            id="dataRecebimentoParcial"
            label-for="dataRecebimentoParcial"
            label="Data de recebimento"
            class="mr-5"
          >
            <b-form-datepicker
              v-model="dataRecebimentoParcial"
              locale="pt-br"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            />
          </b-form-group>
          <b-form-group
            id="contaRecebimentoParcial"
            label-for="contaRecebimentoParcial"
            label="Conta"
            class="mr-5"
          >
            <b-form-select v-model="contaParcial">
              <b-form-select-option
                v-for="b in bancos"
                :key="b.id_banco + 'bancos'"
                :value="b"
              >
                {{ b.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
          <b-form-group
            id="meioPagamentoParcial"
            label-for="meioPagamentoParcial"
            label="Meio de pagamento"
          >
            <b-form-select v-model="meioPagamentoParcial">
              <b-form-select-option
                v-for="meio in meiosPagamentos"
                :key="meio.id + 'meio'"
                :value="meio"
              >
                {{ meio.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </div>
        <div>
          <b-button
            variant="primary"
            @click="receberParcialMassa"
            ref="receber_parcial_massa"
            class="mr-5"
          >
            Receber
          </b-button>
          <b-button
            @click="
              {
                resetParcialData();
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="receberParcial"
      title="Recebimento parcial de Conta?"
      centered
      size="lg"
      v-if="actionsStore.selectedRows.length === 1"
    >
      <b-row class="mb-4">
        <b-col>
          <b-form-checkbox
            name="nfe-saida"
            switch
            size="lg"
            v-model="descontoParcial"
            >Receber Parcial / Desconto</b-form-checkbox
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group id="documento" label-for="documento" label="Documento">
            <b-form-input
              :value="actionsStore.selectedRows[0]?.documento"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="cliente" label-for="cliente" label="Cliente">
            <b-form-input
              :value="actionsStore.selectedRows[0]?.cliente"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="data_vencimento"
            label-for="data_vencimento"
            label="Vencimento"
          >
            <b-form-input
              :value="formatDate(actionsStore.selectedRows[0]?.data_vencimento)"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="data_recebimento"
            label-for="data_recebimento"
            label="Recebimento"
          >
            <b-form-input
              :value="
                formatDate(actionsStore.selectedRows[0]?.data_recebimento)
              "
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="valor" label-for="valor" label="Valor R$">
            <b-form-input
              :value="
                numberToReal(
                  parseFloat(actionsStore.selectedRows[0]?.valor ?? 0),
                  2
                )
              "
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="juros" label-for="juros" label="Juros R$">
            <b-form-input
              :value="
                numberToReal(
                  parseFloat(actionsStore.selectedRows[0]?.juros ?? 0),
                  2
                )
              "
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="multa" label-for="multa" label="Multa R$">
            <b-form-input
              :value="
                numberToReal(
                  parseFloat(actionsStore.selectedRows[0]?.multa ?? 0),
                  2
                )
              "
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="desconto" label-for="desconto" label="Desconto R$">
            <b-form-input
              :value="
                numberToReal(
                  parseFloat(actionsStore.selectedRows[0]?.desconto ?? 0),
                  2
                )
              "
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="border-bottom">
        <b-col md="3">
          <b-form-group
            id="valor_total"
            label-for="valor_total"
            label="Vlr. Receber R$"
          >
            <b-form-input
              :value="
                numberToReal(
                  parseFloat(actionsStore.selectedRows[0]?.valor_total ?? 0),
                  2
                )
              "
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          <b-form-group
            id="dataVencimento"
            label-for="dataVencimento"
            label="Data Vencimento"
          >
            <b-form-datepicker
              v-model="dataVencimentoParcial"
              locale="pt-br"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="dataRecebimento"
            label-for="dataRecebimento"
            label="Data Recebimento"
          >
            <b-form-datepicker
              v-model="dataRecebimentoParcial"
              locale="pt-br"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="bancoRecebimento"
            label-for="bancoRecebimento"
            label="Conta"
            class="mr-5"
          >
            <b-form-select v-model="contaParcial">
              <b-form-select-option
                v-for="b in bancos"
                :key="b.id_banco + 'bancos'"
                :value="b"
              >
                {{ b.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="meioPagamento"
            label-for="meioPagamento"
            label="Meio de pagamento"
          >
            <b-form-select v-model="meioPagamentoParcial">
              <b-form-select-option
                v-for="meio in meiosPagamentos"
                :key="meio.id + 'meio'"
                :value="meio"
              >
                {{ meio.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3">
          <b-form-group label="Valor Recebido R$" label-for="valor_parcial">
            <money
              class="form-control"
              id="valor_parcial"
              name="valor_parcial"
              v-model="valorParcial"
              v-bind="configMask"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="valorParcial > 0">
        <b-col v-if="!descontoParcial">
          Você irá gerar uma nova conta à receber no valor de
          <span class="font-weight-bold text-primary"
            >R${{ numberToReal(parcialValueToDisplay - valorParcial) }}</span
          >
          ?
        </b-col>
        <b-col v-else>
          Você deseja gerar desconto no valor de
          <span class="font-weight-bold text-primary"
            >R${{ numberToReal(parcialValueToDisplay - valorParcial, 2) }}</span
          >
          ?
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="receberParcial"
            ref="receber_parcial"
            class="mr-5"
          >
            Receber
          </b-button>
          <b-button
            @click="
              {
                resetParcialData();
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="menuAcoes" title="Recebimento em massa" centered size="xl">
      <b-form class="form">
        <div class="d-flex" style="max-height: 450px; overflow: auto">
          <b-table
            v-if="actionsStore.selectedRows.length > 0"
            striped
            small
            hover
            :items="recebimentoTableItems"
            :fields="actionTableFields"
          >
            <template #cell(actions)="row">
              <button
                type="button"
                class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
                v-b-tooltip.hover.bottom="'Excluir'"
                @click="() => handleRemoveContaAReceber(row)"
              >
                <TrashCanIcon :size="16" />
              </button>
            </template>
          </b-table>
        </div>
      </b-form>
      <template #modal-footer="{ ok, cancel }">
        <div class="d-flex">
          <DatePickerInput
            label="Data de recebimento"
            @valueUpdated="
              (date) => {
                dataRecebimento = date;
              }
            "
            mode="single"
          />
          <b-form-group
            id="bancoRecebimento"
            label-for="bancoRecebimento"
            label="Conta"
            class="mr-5"
          >
            <b-form-select v-model="bancoRecebimento">
              <b-form-select-option
                v-for="b in bancos"
                :key="b.id_banco + 'bancos'"
                :value="b"
              >
                {{ b.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
          <b-form-group
            id="meioPagamento"
            label-for="meioPagamento"
            label="Meio de pagamento"
          >
            <b-form-select v-model="meioPagamentoRecebimento">
              <b-form-select-option
                v-for="meio in meiosPagamentos"
                :key="meio.id + 'meio'"
                :value="meio"
              >
                {{ meio.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group
            label="Total do recebimento R$"
            label-for="totalRecebimento"
            class="ml-5"
          >
            <money
              class="form-control"
              id="totalRecebimento"
              name="totalRecebimento"
              :value="totalRecebimento"
              disabled
              v-bind="configMask"
            />
          </b-form-group>

          <!-- Campo de desconto corrigido -->
          <b-form-group
            label="Desconto (rateado) R$"
            label-for="descontoRecebimento"
            class="ml-3"
          >
            <money
              class="form-control"
              id="descontoRecebimento"
              name="descontoRecebimento"
              v-model.number="descontoRecebimento"
              v-bind="configMask"
              :masked="false"
              @input="onDescontoInput"
            />
          </b-form-group>
        </div>
        <div>
          <b-button
            variant="primary"
            @click="receberContas"
            ref="receber_contas"
            class="mr-5"
          >
            Receber
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                descontoRecebimento = 0;
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="agruparContas"
      title="Agrupar contas a receber"
      centered
      size="xl"
    >
      <b-form class="form">
        <div class="d-flex" style="max-height: 450px; overflow: auto">
          <b-table
            v-if="actionsStore.selectedRows.length > 0"
            striped
            small
            hover
            :items="agrupamentoTableItems"
            :fields="actionTableFields"
          >
            <template #cell(actions)="row">
              <button
                type="button"
                class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
                v-b-tooltip.hover.bottom="'Excluir'"
                @click="() => handleRemoveContaAReceber(row)"
              >
                <TrashCanIcon :size="16" />
              </button>
            </template>
          </b-table>
        </div>
      </b-form>
      <template #modal-footer="{ ok, cancel }">
        <div class="d-flex">
          <DatePickerInput
            label="Vencimento da nova conta"
            @valueUpdated="
              (date) => {
                dataVencimentoAgrupamento = date;
              }
            "
            mode="single"
          />
          <b-form-group
            id="bancoAgrupamento"
            label-for="bancoAgrupamento"
            label="Conta"
            class="mr-5"
          >
            <b-form-select v-model="bancoAgrupamento">
              <b-form-select-option
                v-for="b in bancos"
                :key="b.id_banco + 'bancosAgrupamento'"
                :value="b"
              >
                {{ b.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
          <b-form-group
            id="meioPagamentoAgrupamento"
            label-for="meioPagamentoAgrupamento"
            label="Meio de pagamento"
          >
            <b-form-select v-model="meioPagamentoAgrupamento">
              <b-form-select-option
                v-for="meio in meiosPagamentos"
                :key="meio.id + 'meioAgrupamento'"
                :value="meio"
              >
                {{ meio.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group
            label="Total agrupado R$"
            label-for="totalAgrupamento"
            class="ml-5"
          >
            <money
              class="form-control"
              id="totalAgrupamento"
              name="totalAgrupamento"
              :value="totalAgrupamento"
              disabled
              v-bind="configMask"
            />
          </b-form-group>

          <b-form-group
            label="Desconto R$"
            label-for="descontoAgrupamento"
            class="ml-3"
          >
            <money
              class="form-control"
              id="descontoAgrupamento"
              name="descontoAgrupamento"
              v-model.number="descontoAgrupamento"
              v-bind="configMask"
              :masked="false"
            />
          </b-form-group>
        </div>
        <div>
          <b-button
            variant="primary"
            @click="agruparContas"
            ref="agrupar_contas"
            class="mr-5"
          >
            Agrupar
          </b-button>
          <b-button
            @click="
              {
                resetAgrupamentoData();
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <TableApp
      titulo="Contas a Receber"
      acaoBtn="/#/contasReceber/novo"
      textoBtn="Nova"
      api-url="/contareceber"
      :fields="fields"
      classFilterColumn="historico"
      ref="contaReceber"
      :perPage="10"
      :multiselect="true"
    >
      <template slot="customRow" scope="props">
        <span slot="documento" v-if="props.field == 'documento'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <div>
                <a
                  v-if="!props.rowData.inativa"
                  class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                  >{{ props.rowData.documento }}</a
                >
                <span
                  class="text-muted font-weight-bold d-block"
                  v-if="!props.rowData.inativa"
                >
                  {{ props.rowData.historico }}
                </span>
                <span v-if="!props.rowData.inativa && props.rowData.plano_contas" class="text-muted d-block" style="font-size: 0.8rem">
                  {{ props.rowData.plano_contas }}
                </span>
                <a
                  v-if="props.rowData.inativa"
                  class="text-muted font-weight-bolder text-hover-primary mb-1 font-size-lg inativa-link"
                  >{{ props.rowData.documento }}</a
                >
                <span
                  v-if="props.rowData.inativa"
                  class="text-muted font-weight-bold d-block inativa-link"
                >
                  {{ props.rowData.historico }}
                </span>
                <span v-if="props.rowData.inativa && props.rowData.plano_contas" class="text-muted d-block inativa-link" style="font-size: 0.8rem">
                  {{ props.rowData.plano_contas }}
                </span>
              </div>
            </div>
          </span>
        </span>
        <template v-if="props.field == 'cliente'">
          <div class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <div>
                <span class="text-muted font-weight-bold d-block">
                  {{ props.rowData.cliente }}
                </span>
                <span
                  v-if="props.rowData.cnpj_cpf"
                  class="text-muted d-block"
                  style="font-size: 0.85rem; cursor: pointer"
                  @click="copyToClipboard(props.rowData.cnpj_cpf)"
                  title="Clique para copiar"
                >
                  {{ formatCpfCnpj(props.rowData.cnpj_cpf) }}
                </span>
              </div>
            </div>
          </div>
        </template>
        <span slot="data_vencimento" v-if="props.field == 'data_vencimento'">
          <div class="font-weight-bold text-muted">
            {{ formatDate(props.rowData.data_vencimento) }}
          </div>
        </span>
        <span slot="data_recebimento" v-if="props.field == 'data_recebimento'">
          <div
            class="font-weight-bold text-muted"
            v-if="props.rowData.data_recebimento != null"
          >
            {{ formatDate(props.rowData.data_recebimento) }}
          </div>
        </span>
        <span slot="created_at" v-if="props.field == 'created_at'">
          <div class="font-weight-bold text-muted">
            {{ formatDate(props.rowData.created_at) }}
          </div>
        </span>
        <span slot="valor" v-if="props.field == 'valor'">
          <div
            v-if="props.rowData.valor_total > 0"
            v-b-tooltip="
              'Conta está calculando Juros: Valor Orignal + Juros + Multa - Desconto'
            "
          >
            <span class="text-dark-75 font-weight-bolder d-block font-size-lg"
              >R$ {{ numberToReal(props.rowData.valor_total, 2) }}</span
            >
            <span
              class="text-muted font-weight-bold d-block"
              style="font-size: 12px"
            >
              R$ {{ numberToReal(props.rowData.valor, 2) }} +
              {{ numberToReal(props.rowData.juros, 2) }} +
              {{ numberToReal(props.rowData.multa, 2) }} -
              {{ numberToReal(props.rowData.desconto, 2) }}
            </span>
          </div>
          <span
            class="text-dark-75 font-weight-bolder d-block font-size-lg"
            v-else
            >R$ {{ numberToReal(props.rowData.valor, 2) }}</span
          >
        </span>
        <span slot="meio_pagamento" v-if="props.field == 'meio_pagamento'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <span class="text-muted font-weight-bold d-block">{{
                props.rowData.meio_pagamento
              }}</span>
              <span v-if="props.rowData.id_conciliacao_bancaria || props.rowData.foi_conciliado_ofx" class="ml-2" style="display: inline-block" v-b-tooltip.hover.bottom="'Conciliado via OFX'">
                <CheckCircle :size="14" class="text-success" />
              </span>
            </div>
          </span>
        </span>
        <span slot="status" v-if="props.field == 'status'">
          <div class="d-flex align-items-center">
            <div v-html="onRowStatus(props.rowData)"></div>
            <span
              v-if="props.rowData.agrupada"
              class="agrupamento-info ml-2"
              v-b-tooltip.hover.bottom="
                'Documento gerado no agrupamento: ' +
                getDocumentoAgrupamento(props.rowData)
              "
            >
              !
            </span>
          </div>
        </span>
        <span slot="actions" v-if="props.field == 'actions'">
          <div class="row-actions" style="text-align: right !important">
            <span
              style="
                display: inline-block;
                overflow: visible;
                position: relative;
                width: 210px;
              "
            >
              <div class="dropdown dropdown-inline">
                <router-link
                  class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
                  v-if="
                    !props.rowData.data_recebimento && !props.rowData.agrupada
                  "
                  :to="{
                    name: 'contasReceberEditar',
                    params: { id: props.rowData.id },
                  }"
                >
                  <Pencil :size="16" title="Editar" />
                </router-link>
                <button
                  v-if="
                    props.rowData.url_boleto &&
                    !props.rowData.data_recebimento &&
                    !props.rowData.agrupada &&
                    props.rowData.status_boleto != 'request_cancel'
                  "
                  @click="visualizarBoleto(props.rowData)"
                  class="btn btn-sm btn-primary btn-hover-primary btn-icon mr-2"
                  v-b-tooltip.hover.bottom="'Visualizar Boleto'"
                >
                  <Download :size="16" />
                </button>
                <button
                  v-if="podeCompartilharBoleto(props.rowData)"
                  @click="abrirWhatsappBoleto(props.rowData)"
                  class="btn btn-sm btn-success btn-hover-success btn-icon mr-2"
                  v-b-tooltip.hover.bottom="'Enviar boleto pelo WhatsApp'"
                >
                  <Whatsapp :size="16" />
                </button>
                <button
                  v-if="podeCompartilharBoleto(props.rowData)"
                  @click="copiarLinkBoleto(props.rowData)"
                  class="btn btn-sm btn-success btn-hover-success btn-icon mr-2"
                  v-b-tooltip.hover.bottom="'Copiar link do boleto'"
                >
                  <Link :size="16" />
                </button>
                <button
                  v-if="
                    !props.rowData.agrupada &&
                    ((!props.rowData.data_recebimento &&
                      !props.rowData.receipt_id &&
                      !props.rowData.url_boleto) ||
                      props.rowData.status_boleto == 'request_cancel')
                  "
                  @click="gerarBoleto(props.rowData)"
                  class="btn btn-sm btn-primary btn-hover-primary btn-icon mr-2"
                  v-b-tooltip.hover.bottom="'Gerar Boleto'"
                >
                  <Boleto :size="16" />
                </button>
                <button
                  v-if="
                    props.rowData.zoop_boleto_id ||
                    props.rowData.id_transaction_digital &&
                    !props.rowData.data_recebimento &&
                    !props.rowData.agrupada &&
                    props.rowData.status_boleto != 'request_cancel'
                  "
                  @click="cancelarBoleto(props.rowData)"
                  class="btn btn-sm btn-primary btn-hover-primary btn-icon mr-2"
                  v-b-tooltip.hover.bottom="'Cancelar Boleto'"
                >
                  <Cancel :size="16" />
                </button>
                <button
                  v-if="
                    props.rowData.id_empresa &&
                    !props.rowData.data_recebimento &&
                    !props.rowData.agrupada
                  "
                  @click="excluir(props.rowData)"
                  class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
                >
                  <TrashCanIcon :size="16" />
                </button>
              </div>
            </span>
          </div>
        </span>
      </template>
    </TableApp>
    <Chart endpoint="/contareceber/total" modulo="contareceber" v-if="currentUser.admin"/>

  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import Download from "vue-material-design-icons/Download.vue";
import Boleto from "vue-material-design-icons/CurrencyBrl.vue";
import Cancel from "vue-material-design-icons/Cancel.vue";
import CheckCircle from "vue-material-design-icons/CheckCircle.vue";
import Whatsapp from "vue-material-design-icons/Whatsapp.vue";
import Link from "vue-material-design-icons/LinkPlus.vue";
import swal from "sweetalert";
import Chart from "@/components/Charts/Charts.vue";
import DatePickerInput from "@/components/DatePickerInput/index.vue";
import FilterFields from "@/components/FilterFields";
import Menu from "vue-material-design-icons/Menu";
import { actionsStore } from "@/components/Table/actionsStore";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import { filtersStore } from "@/components/FilterFields/filtersStore";
import TableApp from "@/components/Table/Table2";
import { SistemaMixin } from "@/modules/Application";

export default {
  name: "app-contareceber",
  mixins: [SistemaMixin],
  components: {
    Pencil,
    TrashCanIcon,
    TableApp,
    Download,
    Boleto,
    Cancel,
    CheckCircle,
    Whatsapp,
    Link,
    Chart,
    FilterFields,
    Menu,
    Money,
    DatePickerInput,
  },
  data() {
    return {
      actionsStore,
      filtersStore,
      valorParcial: 0,
      dataRecebimentoParcial: null,
      dataVencimentoParcial: null,
      recebimentoParcialItems: [],
      meioPagamentoParcial: null,
      contaParcial: null,
      descontoParcial: false,
      configMask: settingMoney,
      resumo: {},
      meioPagamentoRecebimento: null,
      meioPagamentoAgrupamento: null,
      meioPagamentos: [],
      bancoRecebimento: null,
      bancoAgrupamento: null,
      showTooltipMenu: false,
      dataRecebimento: null,
      dataVencimentoAgrupamento: null,
      bancos: [{ id_banco: 99999, nome: "Movimento Caixa" }],
      cobrancaContaSelecionada: null,
      fields: [
        {
          label: "Documento",
          field: "documento",
          type: "text",
          slot: true,
          sortable: true,
          width: "10%",
        },
        {
          label: "Cliente",
          field: "cliente",
          type: "text",
          slot: true,
          sortable: true,
          width: "20%",
        },
        {
          label: "Emissão",
          field: "created_at",
          type: "date",
          filterable: true,
          slot: true,
          dateInputFormat: "yyyy-MM-dd",
          dateOutputFormat: "dd-MM-yyyy",
          width: "8%",
        },
        {
          label: "Vencimento",
          field: "data_vencimento",
          type: "date",
          filterable: true,
          slot: true,
          dateInputFormat: "yyyy-MM-dd",
          dateOutputFormat: "dd-MM-yyyy",
          width: "8%",
        },
        {
          label: "Recebido",
          field: "data_recebimento",
          type: "date",
          slot: true,
          dateInputFormat: "yyyy-MM-dd",
          dateOutputFormat: "dd-MM-yyyy",
          width: "8%",
        },
        {
          label: "Valor",
          field: "valor",
          slot: true,
          width: "10%",
          filterOptions: { enabled: false },
        },
        {
          label: "M.Pag",
          field: "meio_pagamento",
          slot: true,
          width: "15%",
          filterOptions: { enabled: false },
        },
        { label: "Status", field: "status", sortable: false, slot: true },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "30%",
        },
      ],
      actionTableFields: [
        { key: "documento", label: "Documento" },
        { key: "cliente", label: "Cliente" },
        { key: "vencimento", label: "Vencimento" },
        { key: "recebimento", label: "Recebimento" },
        { key: "valor", label: "Valor R$" },
        { key: "juros", label: "Juros R$" },
        { key: "multa", label: "Multa R$" },
        { key: "desconto", label: "Desconto R$" },
        { key: "valor_total", label: "Vlr. Receber R$" },
        { key: "status", label: "Status" },
        { key: "actions", label: "" },
      ],
      recebimentoParcialTableFields: [
        { key: "documento", label: "Documento" },
        { key: "cliente", label: "Cliente" },
        { key: "vencimento_atual", label: "Vencimento atual" },
        { key: "valor_total", label: "Valor a receber" },
        { key: "valor_parcial", label: "Valor recebido R$" },
        { key: "data_vencimento", label: "Vencimento da nova conta" },
        { key: "saldo_restante", label: "Saldo restante" },
      ],
      boletoEvent: null,
      descontoRecebimento: 0, // total a ratear
      descontoAgrupamento: 0,
    };
  },
  watch: {
    boletoEvent(newValue, oldValue) {
      if (newValue !== oldValue) {
        window.Echo.leaveChannel("boletoChannel");
      }
    },
    "filtersStore.filterOptionSelected": {
      handler(value) {
        switch (value.id) {
          case 1:
            this.getCurrentDayData("contasReceber");
            break;
          case 2:
            this.getYesterdayData("contasReceber");
            break;
          case 3:
            this.getCurrentWeekData("contasReceber");
            break;
          case 4:
            this.getLastWeekData("contasReceber");
            break;
          case 5:
            this.getMonthData("contasReceber");
            break;
          default:
            break;
        }
      },
      deep: true,
    },
    valorParcial(newValue) {
      if (!this.actionsStore.selectedRows[0]) {
        return (this.valorParcial = newValue);
      }
      let valorTotalContaReceber = parseFloat(
        this.actionsStore.selectedRows[0].valor
      );
      if (parseFloat(this.actionsStore.selectedRows[0].valor_total) > 0) {
        valorTotalContaReceber = this.actionsStore.selectedRows[0].valor_total;
      }
      if (newValue > valorTotalContaReceber) {
        return (this.valorParcial = valorTotalContaReceber);
      }
      return (this.valorParcial = newValue);
    },
    // re-rateia quando seleção muda
    "actionsStore.selectedRows": {
      deep: true,
      handler() {
        this.ratearDesconto();
      },
    },
    // mantém numérico e re-rateia quando digita
    descontoRecebimento(val) {
      this.descontoRecebimento = this._unmaskMoney(val);
      this.ratearDesconto();
    },
  },
  methods: {
    _unmaskMoney(val) {
      if (val == null) return 0;
      if (typeof val === "number") return val;
      const str = String(val)
        .replace(/\s/g, "")
        .replace(/\./g, "")
        .replace(",", ".");
      const n = parseFloat(str);
      return isNaN(n) ? 0 : n;
    },
    onDescontoInput(val) {
      this.descontoRecebimento = this._unmaskMoney(val);
      this.$nextTick(() => this.ratearDesconto());
    },
    _toCents(n) {
      return Math.round(Number(n || 0) * 100);
    },
    // >>> REFEITO: com this.$set e $forceUpdate (funciona inclusive com 1 conta)
    ratearDesconto() {
      // garante numérico
      this.descontoRecebimento = this._unmaskMoney(this.descontoRecebimento);

      const rows = (this.actionsStore?.selectedRows || []).filter(
        (r) => this.onRowStatus(r, true) !== "Recebida"
      );

      if (!rows.length) {
        (this.actionsStore?.selectedRows || []).forEach((r) =>
          this.$set(r, "_descontoRateado", 0)
        );
        this.$forceUpdate();
        return;
      }

      // base proporcional por parcela
      const bases = rows.map((r) => {
        const valor = parseFloat(r.valor || 0);
        const juros = parseFloat(r.juros || 0);
        const multa = parseFloat(r.multa || 0);
        const desconto = parseFloat(r.desconto || 0);
        const base = Math.max(valor + juros + multa - desconto, 0);
        return { r, base };
      });

      const totalBase = bases.reduce((acc, b) => acc + b.base, 0);
      let totalDescCents = this._toCents(this.descontoRecebimento);
      const maxCents = this._toCents(totalBase);

      // clamp do total ao máximo possível
      if (totalDescCents > maxCents) {
        totalDescCents = maxCents;
        this.descontoRecebimento = maxCents / 100;
      }

      if (totalBase <= 0 || totalDescCents <= 0) {
        rows.forEach((r) => this.$set(r, "_descontoRateado", 0));
        this.$forceUpdate();
        return;
      }

      // rateio proporcional em centavos
      let soma = 0;
      const partes = bases.map((b) => {
        const exata = (b.base / totalBase) * totalDescCents;
        const cota = Math.floor(exata);
        soma += cota;
        return { ...b, exata, cota, residuo: exata - cota };
      });

      // distribui sobras para maiores resíduos
      let resto = totalDescCents - soma;
      partes.sort((a, b) => b.residuo - a.residuo);
      for (let i = 0; i < partes.length && resto > 0; i++) {
        partes[i].cota += 1;
        resto -= 1;
      }

      // aplica reativamente
      partes.forEach((p) => {
        const valor = parseFloat(p.r.valor || 0);
        const juros = parseFloat(p.r.juros || 0);
        const multa = parseFloat(p.r.multa || 0);
        const desconto = parseFloat(p.r.desconto || 0);
        const maxDescParcela = Math.max(valor + juros + multa - desconto, 0);
        const descAplicado = Math.min(p.cota / 100, maxDescParcela);
        this.$set(p.r, "_descontoRateado", descAplicado);
      });

      // re-render imediato
      this.$forceUpdate();
    },

    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => this.$toast.success("Conteúdo copiado com sucesso!"))
        .catch(() => this.$toast.error("Não foi possível copiar"));
    },
    podeCompartilharBoleto(conta) {
      return !!conta?.url_boleto && !conta?.data_recebimento && !conta?.agrupada;
    },
    getMensagemBoletoWhatsapp(conta) {
      const documento = conta?.documento
        ? ` referente ao documento ${conta.documento}`
        : "";
      return `Olá! Segue o link do boleto${documento}: ${conta.url_boleto}`;
    },
    async obterUrlBoletoParaCompartilhar(conta, acao) {
      if (!this.podeCompartilharBoleto(conta)) {
        this.$toast.error("Conta indisponível para envio de boleto.");
        return null;
      }

      if (conta.url_boleto && conta.status_boleto != "request_cancel") {
        return conta.url_boleto;
      }

      const value = await swal({
        title: "Esta conta ainda não possui boleto gerado.",
        text: `Deseja gerar o boleto agora para ${acao}?`,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "Gerar boleto",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      });

      if (value === "cancel") {
        swal.close();
        swal.stopLoading();
        return null;
      }

      try {
        const result = await this.$http.post("/boletos/create", {
          id_conta_receber: conta.id,
        });
        const urlBoleto = result?.data?.url_boleto;

        swal.stopLoading();
        swal.close();

        if (!urlBoleto) {
          this.$toast.error("Não foi possível gerar o link do boleto.");
          return null;
        }

        conta.url_boleto = urlBoleto;
        conta.status_boleto =
          result?.data?.status_boleto || conta.status_boleto;
        this.$refs.contaReceber.refresh();
        this.$toast.success("Boleto gerado com sucesso!");

        return urlBoleto;
      } catch (error) {
        swal.stopLoading();
        swal.close();
        const mensagem =
          error?.response?.data?.msg || "Não foi possível gerar o boleto.";
        this.$toast.error(mensagem);
        return null;
      }
    },
    async abrirWhatsappBoleto(conta) {
      const urlBoleto = await this.obterUrlBoletoParaCompartilhar(
        conta,
        "enviar pelo WhatsApp"
      );

      if (!urlBoleto) {
        return;
      }

      conta.url_boleto = urlBoleto;

      if (!this.podeCompartilharBoleto(conta)) {
        this.$toast.error("Boleto sem link disponível para envio.");
        return;
      }

      const url = `https://wa.me/?text=${encodeURIComponent(
        this.getMensagemBoletoWhatsapp(conta)
      )}`;
      window.open(url, "_blank", "noopener,noreferrer");
    },
    async copiarLinkBoleto(conta) {
      const urlBoleto = await this.obterUrlBoletoParaCompartilhar(
        conta,
        "copiar o link"
      );

      if (!urlBoleto) {
        return;
      }

      if (!this.podeCompartilharBoleto(conta)) {
        this.$toast.error("Boleto sem link disponível para copiar.");
        return;
      }

      this.$copyText(urlBoleto);
      this.$toast.success("Link do boleto copiado com sucesso!");
    },
    async getDataInit() {
      const bancos = await this.getBancosByEmpresa();
      this.bancos.push(...bancos);
      this.bancoRecebimento = this.bancos[0];
      this.contaParcial = this.bancos[0];
      const response = await this.$http.post("/financeiro/meios-pagamento");
      this.meiosPagamentos = response.data;
      this.meioPagamentoRecebimento = this.meiosPagamentos[0];
      this.meioPagamentoParcial = this.meiosPagamentos[0];
      this.bancoAgrupamento = this.bancos[0];
      this.meioPagamentoAgrupamento = this.meiosPagamentos[0];
    },
    resolverMensagemErroBoleto(payload = {}) {
      const texto = String(
        payload?.error || payload?.type || payload?.code || payload?.msg || ""
      ).toLowerCase();

      if (texto.includes("certificado")) {
        return "Empresa não possui certificado digital cadastrado no emitente.";
      }
      if (texto.includes("client_id") || texto.includes("client id")) {
        return "Conta bancária Sicoob sem Client ID configurado.";
      }
      if (
        texto.includes("numero_cliente") ||
        texto.includes("número cliente") ||
        texto.includes("convenio") ||
        texto.includes("convênio")
      ) {
        return "Conta bancária Sicoob sem Número Cliente configurado.";
      }
      if (texto.includes("modalidade") || texto.includes("carteira")) {
        return "Conta bancária Sicoob sem Código Modalidade configurado.";
      }
      if (texto.includes("cpf") || texto.includes("cnpj")) {
        return "Cliente precisa ter CPF/CNPJ para gerar boleto.";
      }
      if (texto.includes("sicoob")) {
        return "Erro ao comunicar com Sicoob.";
      }

      return (
        payload?.msg ||
        payload?.message ||
        "Não foi possível gerar o boleto."
      );
    },
    getContaBancariaPayload(conta) {
      const contaBancariaId =
        conta?.id_banco ||
        conta?.id_conta_bancaria ||
        (typeof conta?.banco === "object" ? conta?.banco?.id_banco : null);

      if (!contaBancariaId) {
        return {};
      }

      return {
        id_banco: contaBancariaId,
        id_conta_bancaria: contaBancariaId,
      };
    },
    temCamposCobrancaRetorno(payload = {}) {
      return Boolean(
        payload?.linha_digitavel ||
          payload?.codigo_barras ||
          payload?.nosso_numero ||
          payload?.qr_code ||
          payload?.pix_copia_cola ||
          payload?.url_boleto ||
          payload?.status_cobranca ||
          payload?.tipo_cobranca
      );
    },
    abrirDetalhesCobranca(conta) {
      this.cobrancaContaSelecionada = conta;
      this.$nextTick(() => this.$bvModal.show("cobrancaDetalhes"));
    },
    getValorTotalParcial(conta) {
      const valorTotal = parseFloat(conta?.valor_total || 0);
      if (valorTotal > 0) {
        return valorTotal;
      }
      return parseFloat(conta?.valor || 0);
    },
    isContaDisponivelParaRecebimento(conta) {
      const status = this.onRowStatus(conta, true);
      return (
        status !== "Recebida" && status !== "Inativa" && status !== "Agrupada"
      );
    },
    abrirRecebimentoParcial() {
      const contasSelecionadas = this.actionsStore.selectedRows || [];
      const contasValidas = contasSelecionadas.filter((conta) =>
        this.isContaDisponivelParaRecebimento(conta)
      );

      if (!contasValidas.length) {
        this.$toast.error(
          "Selecione ao menos uma conta em aberto para receber parcialmente."
        );
        return;
      }

      if (contasValidas.length !== contasSelecionadas.length) {
        this.$toast.warning(
          "Contas recebidas, inativas ou agrupadas não serão processadas."
        );
      }

      if (contasSelecionadas.length === 1) {
        this.dataVencimentoParcial = contasValidas[0].data_vencimento;
        if (!this.contaParcial) {
          this.contaParcial = this.bancos[0];
        }
        if (!this.meioPagamentoParcial) {
          this.meioPagamentoParcial = this.meiosPagamentos[0];
        }
        this.$nextTick(() => this.$bvModal.show("receberParcial"));
        return;
      }

      this.recebimentoParcialItems = contasValidas.map((conta) => ({
        id: conta.id,
        documento: conta.documento,
        cliente: conta.cliente,
        vencimento_atual: conta.data_vencimento,
        data_vencimento: conta.data_vencimento,
        valor_total: this.getValorTotalParcial(conta),
        valor_parcial: 0,
      }));

      if (!this.contaParcial) {
        this.contaParcial = this.bancos[0];
      }
      if (!this.meioPagamentoParcial) {
        this.meioPagamentoParcial = this.meiosPagamentos[0];
      }

      this.$nextTick(() => this.$bvModal.show("receberParcialMassa"));
    },
    getSaldoRestanteParcial(item) {
      const valorParcial = this._unmaskMoney(item?.valor_parcial);
      return Math.max(parseFloat(item?.valor_total || 0) - valorParcial, 0);
    },
    validarRecebimentoParcial() {
      if (
        !this.dataRecebimentoParcial ||
        !this.contaParcial ||
        !this.meioPagamentoParcial
      ) {
        this.$toast.error("Preencha todos os campos necessários.");
        return false;
      }

      const contaSemVencimento = this.recebimentoParcialItems.find(
        (conta) => !conta.data_vencimento
      );
      if (contaSemVencimento) {
        this.$toast.error(
          "Informe o vencimento da nova conta em todos os lançamentos."
        );
        return false;
      }

      const contaComValorInvalido = this.recebimentoParcialItems.find(
        (conta) => {
          const valorParcial = this._unmaskMoney(conta.valor_parcial);
          return valorParcial <= 0 || valorParcial >= conta.valor_total;
        }
      );
      if (contaComValorInvalido) {
        this.$toast.error(
          "O valor recebido deve ser maior que zero e menor que o valor a receber."
        );
        return false;
      }

      return true;
    },
    resetParcialData() {
      this.dataRecebimentoParcial = null;
      this.dataVencimentoParcial = null;
      this.descontoParcial = false;
      this.contaParcial = null;
      this.meioPagamentoParcial = null;
      this.valorParcial = 0;
      this.recebimentoParcialItems = [];
      this.actionsStore.updateTable = !this.actionsStore.updateTable;
      this.actionsStore.selectedRows = [];
    },
    async duplicarConta() {
      const contasSelecionadas = this.actionsStore.selectedRows || [];

      if (contasSelecionadas.length !== 1) {
        this.$toast.error("Selecione apenas uma conta para duplicar.");
        return;
      }

      this.addLoadingToButton("duplicar_conta_receber");
      try {
        await this.$http.post("/contareceber/duplicar", {
          id: contasSelecionadas[0].id,
        });
        this.$toast.success("Conta a receber duplicada com sucesso!");
        this.actionsStore.selectedRows = [];
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$bvModal.hide("duplicarContaReceber");
      } catch (error) {
        const mensagem =
          error?.response?.data?.msg ||
          "Não foi possível duplicar a conta a receber.";
        this.$toast.error(mensagem);
      } finally {
        this.removeLoadingToButton("duplicar_conta_receber");
      }
    },
    handleRemoveContaAReceber({ index }) {
      this.actionsStore.selectedRows = this.actionsStore.selectedRows.filter(
        (row, rowIndex) => index !== rowIndex
      );
      this.ratearDesconto();
    },
    abrirAgrupamentoContas() {
      const contasSelecionadas = this.actionsStore.selectedRows || [];
      const contasValidas = contasSelecionadas.filter((conta) =>
        this.isContaDisponivelParaRecebimento(conta)
      );

      if (contasValidas.length < 2) {
        this.$toast.error("Selecione ao menos duas contas em aberto.");
        return;
      }

      if (contasValidas.length !== contasSelecionadas.length) {
        this.$toast.warning(
          "Contas recebidas, inativas ou já agrupadas não serão agrupadas."
        );
      }

      const primeiroCliente = contasValidas[0].id_pessoa || null;
      const clienteDiferente = contasValidas.some(
        (conta) => (conta.id_pessoa || null) !== primeiroCliente
      );

      if (clienteDiferente) {
        this.$toast.error("Selecione contas do mesmo cliente para agrupar.");
        return;
      }

      this.actionsStore.selectedRows = contasValidas;

      if (!this.bancoAgrupamento) {
        this.bancoAgrupamento = this.bancos[0];
      }
      if (!this.meioPagamentoAgrupamento) {
        this.meioPagamentoAgrupamento = this.meiosPagamentos[0];
      }

      this.$nextTick(() => this.$bvModal.show("agruparContas"));
    },
    resetAgrupamentoData() {
      this.dataVencimentoAgrupamento = null;
      this.bancoAgrupamento = this.bancos[0] || null;
      this.meioPagamentoAgrupamento = this.meiosPagamentos[0] || null;
      this.descontoAgrupamento = 0;
      this.actionsStore.updateTable = !this.actionsStore.updateTable;
      this.actionsStore.selectedRows = [];
    },
    validarAgrupamentoContas() {
      if (this.actionsStore.selectedRows.length < 2) {
        this.$toast.error("Selecione ao menos duas contas para agrupar.");
        return false;
      }

      if (
        !this.dataVencimentoAgrupamento ||
        !this.bancoAgrupamento ||
        !this.meioPagamentoAgrupamento
      ) {
        this.$toast.error("Preencha todos os campos necessários.");
        return false;
      }

      const desconto = this._unmaskMoney(this.descontoAgrupamento);

      if (desconto >= this.totalAgrupamentoBruto) {
        this.$toast.error("O desconto deve ser menor que o total agrupado.");
        return false;
      }

      return true;
    },
    async agruparContas() {
      if (!this.validarAgrupamentoContas()) {
        return;
      }

      this.addLoadingToButton("agrupar_contas");
      try {
        await this.$http.post("/contareceber/agrupar-contas", {
          id_banco: this.bancoAgrupamento.id_banco,
          id_meio_pagamento: this.meioPagamentoAgrupamento.id,
          data_vencimento: this.dataVencimentoAgrupamento,
          desconto: this._unmaskMoney(this.descontoAgrupamento),
          contas_receber: this.actionsStore.selectedRows.map((conta) => ({
            id: conta.id,
          })),
        });
        this.$toast.success("Contas agrupadas com sucesso!");
        this.$refs.contaReceber.refresh();
        this.$bvModal.hide("agruparContas");
        this.resetAgrupamentoData();
      } catch (error) {
        const mensagem =
          error?.response?.data?.msg || "Não foi possível agrupar as contas.";
        this.$toast.error(mensagem);
      } finally {
        this.removeLoadingToButton("agrupar_contas");
      }
    },
    async receberParcial() {
      const contaReceberData = this.actionsStore.selectedRows[0];

      if (
        !this.dataRecebimentoParcial ||
        !this.contaParcial ||
        !this.meioPagamentoParcial ||
        !this.valorParcial
      ) {
        this.$toast.error("Preencha todos os campos necessários!");
        return;
      }
      this.addLoadingToButton("receber_parcial");
      try {
        const { data: dataToSend } = await this.$http.post(
          "/contareceber/receber-parcial",
          {
            id_conta_receber: contaReceberData.id,
            valor_parcial: this.valorParcial,
          }
        );
        await this.$http.post("/contareceber/create-parcial", {
          ...dataToSend,
          data_vencimento: this.dataVencimentoParcial,
          data_recebimento: this.dataRecebimentoParcial,
          id_banco: this.contaParcial.id_banco,
          id_meio_pagamento: this.meioPagamentoParcial.id,
          valor_parcial: this.valorParcial,
          desconto: this.descontoParcial,
        });
        this.$refs.contaReceber.refresh();
      } catch {
        this.$toast.error("Não foi possível realizar o recebimento parcial.");
      }
      this.removeLoadingToButton("receber_parcial");
      this.resetParcialData();
      this.$bvModal.hide("receberParcial");
    },
    async receberParcialMassa() {
      if (!this.validarRecebimentoParcial()) {
        return;
      }

      this.addLoadingToButton("receber_parcial_massa");
      try {
        await this.$http.post("/contareceber/receber-parcial-massa", {
          id_banco: this.contaParcial.id_banco,
          id_meio_pagamento: this.meioPagamentoParcial.id,
          data_recebimento: this.dataRecebimentoParcial,
          contas_receber: this.recebimentoParcialItems.map((conta) => ({
            id: conta.id,
            valor_parcial: this._unmaskMoney(conta.valor_parcial),
            data_vencimento: conta.data_vencimento,
          })),
          desconto: false,
        });
        this.$toast.success("Recebimentos parciais realizados com sucesso!");
        this.$refs.contaReceber.refresh();
        this.$bvModal.hide("receberParcialMassa");
        this.resetParcialData();
      } catch {
        this.$toast.error(
          "Não foi possível realizar os recebimentos parciais."
        );
      } finally {
        this.removeLoadingToButton("receber_parcial_massa");
      }
    },
    async verificaContasReceber() {
      await this.$http
        .post("/boletos/webhook-transacations")
        .then(() => {
          window.Echo.channel("boletoChannel").listen(
            ".boletoEvent",
            (message) => {
              if (message) {
                this.boletoEvent = message.message;
                this.$refs.contaReceber.refresh();
              }
            }
          );
        })
        .catch(() => {});
    },
    async receberContas() {
      const contasValidas = this.actionsStore.selectedRows.filter((conta) =>
        this.isContaDisponivelParaRecebimento(conta)
      );

      if (!contasValidas.length) {
        this.$toast.error("Selecione ao menos uma conta em aberto.");
        return;
      }

      this.addLoadingToButton("receber_contas");
      try {
        await this.$http.post("/contareceber/recebimento", {
          id_banco: this.bancoRecebimento.id_banco,
          id_meio_pagamento: this.meioPagamentoRecebimento.id,
          data_recebimento: this.dataRecebimento,
          contas_receber: contasValidas.map((conta) => ({
            id: conta.id,
          })),
          //          Se quiser enviar o rateio para o backend, envie junto:
          descontos_rateados: contasValidas.map((c) => ({
            id: c.id,
            desconto_rateado: c._descontoRateado || 0,
          })),
        });
        this.actionsStore.selectedRows = [];
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.meioPagamentoRecebimento = null;
        this.bancoRecebimento = null;
        this.descontoRecebimento = 0;
        this.$toast.success("Contas recebidas com sucesso!");
        this.$refs.contaReceber.refresh();
        this.$bvModal.hide("menuAcoes");
      } catch (error) {
        console.log(error);
        this.meioPagamentoRecebimento = null;
        this.bancoRecebimento = null;
        this.$bvModal.hide("menuAcoes");
        this.descontoRecebimento = 0;
      }
      this.removeLoadingToButton("receber_contas");
    },
    dateRangeFilter(data, filterString) {
      let dateRange = filterString.split("to");
      let startDate = Date.parse(dateRange[0]);
      let endDate = Date.parse(dateRange[1]);
      return (data =
        Date.parse(data) >= startDate && Date.parse(data) <= endDate);
    },
    onRowStatus(dataItem, onlyLabel = false) {
      if (dataItem.inativa) {
        return !onlyLabel
          ? '<span class="label label-lg label-light-dark label-inline">Inativa</span>'
          : "Inativa";
      }
      if (dataItem.agrupada) {
        return !onlyLabel
          ? '<span class="label label-lg label-light-primary label-inline">Agrupada</span>'
          : "Agrupada";
      }
      if (
        dataItem.data_vencimento < this.thisDate() &&
        dataItem.data_recebimento === null
      ) {
        return !onlyLabel
          ? '<span class="label label-lg label-light-danger label-inline">Vencida</span>'
          : "Vencida";
      }
      if (
        dataItem.data_vencimento > this.thisDate() &&
        dataItem.data_recebimento === null
      ) {
        return !onlyLabel
          ? '<span class="label label-lg label-light-warning label-inline">A receber</span>'
          : "A receber";
      }
      if (dataItem.data_recebimento !== null) {
        return !onlyLabel
          ? '<span class="label label-lg label-light-success label-inline">Recebida</span>'
          : "Recebida";
      }
      return "";
    },
    getDocumentoAgrupamento(dataItem) {
      return dataItem.documento_agrupamento || "não informado";
    },
    gerarBoleto(data) {
      swal({
        title:
          "Deseja gerar o boleto referente a conta: " + data.historico + "?",
        text: "Aguarde, pois o link será gerado automaticamente!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: { text: "OK", visible: true, closeModal: false },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/boletos/create", {
            id_conta_receber: data.id,
            ...this.getContaBancariaPayload(data),
          })
          .then((result) => {
            const payload = result?.data || {};

            this.cobrancaContaSelecionada = {
              ...data,
              ...payload,
            };

            if (result["data"]["url_boleto"])
              window.open(result["data"]["url_boleto"], "_blank");

            swal.stopLoading();
            swal.close();
            this.$toast.success("Boleto gerado com sucesso!");
            this.$refs.contaReceber.refresh();

            if (this.temCamposCobrancaRetorno(payload)) {
              this.$nextTick(() => this.$bvModal.show("cobrancaDetalhes"));
            }
          })
          .catch((error) => {
            swal.stopLoading();
            swal.close();
            this.$toast.error(
              this.resolverMensagemErroBoleto(error?.response?.data || {})
            );
          });
      });
    },
    enviarBoletoEmail(data) {
      this.$swal
        .fire({
          icon: "warning",
          title:
            "Deseja visualizar o boleto referente a conta: " +
            data.historico +
            "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.$http.post("/boletos/enviar-email", {
              id_conta_receber: data.id,
            });
            this.$refs.contaReceber.refresh();
            this.$toast.success("Boleto enviado com sucesso!");
          }
        });
    },
    cancelarBoleto(data) {
      this.getRequestAdmin(() => {
        this.$swal
          .fire({
            icon: "warning",
            title:
              "Deseja cancelar o boleto referente a conta: " +
              data.historico +
              "?",
            showCancelButton: true,
            confirmButtonText: `Sim`,
            cancelButtonText: `Não`,
            confirmButtonColor: "#f64e60",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              await this.$http.post("/boletos/cancel", {
                id_conta_receber: data.id,
              });
              this.$refs.contaReceber.refresh();
              this.$toast.success("Boleto cancelado com sucesso!");
            }
          });
      });
    },
    visualizarBoleto(data) {
      this.$swal
        .fire({
          icon: "warning",
          title:
            "Deseja visualizar o boleto referente a conta: " +
            data.historico +
            "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            if (data.url_boleto) window.open(data.url_boleto, "_blank");
            this.$refs.contaReceber.refresh();
            this.$toast.success("Boleto visualizado com sucesso!");
          }
        });
    },
    excluir(data) {
      this.getRequestAdmin(() => {
        this.$swal
          .fire({
            icon: "warning",
            title: "Excluir o lançamento: " + data.historico + "?",
            showCancelButton: true,
            confirmButtonText: `Sim`,
            cancelButtonText: `Não`,
            confirmButtonColor: "#f64e60",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              await this.$http.post("/contareceber/delete", { id: data.id });
              this.$refs.contaReceber.refresh();
              this.$toast.success("Lançamento excluído!");
            }
          });
      });
    },
    async estornar() {
      this.addLoadingToButton("estornar_contas");
      try {
        await this.$http.post("/contareceber/estornar", {
          contas_receber: this.actionsStore.selectedRows.map((conta) => ({
            id: conta.id,
          })),
        });
        this.actionsStore.selectedRows = [];
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Contas estornadas com sucesso!");
        this.$refs.contaReceber.refresh();
        this.$bvModal.hide("menuAcoes");
        this.$bvModal.hide("estornarContas");
      } catch (error) {
        this.$bvModal.hide("estornarContas");
      }
      this.removeLoadingToButton("estornar_contas");
    },
    async gerarCarneBoletoReduzido() {
      this.addLoadingToButton("gerarCarneBoleto");
      try {
        await this.$http
          .post("/contareceber/carne-reduzido", {
            contas_receber: this.actionsStore.selectedRows.map((conta) => ({
              id: conta.id,
            })),
          })
          .then((result) => {
            if (result["data"]["carne"]) {
              this.actionsStore.selectedRows = [];
              this.actionsStore.updateTable = !this.actionsStore.updateTable;
              this.$toast.success("Carnê gerado com sucesso!");
              this.$refs.contaReceber.refresh();
              this.$bvModal.hide("menuAcoes");
              this.$bvModal.hide("gerarCarneBoleto");
              window.open(result["data"]["carne"], "_blank");
            }
            swal.stopLoading();
            swal.close();
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
        this.actionsStore.selectedRows = [];
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Carnê gerado com sucesso!");
        this.$refs.contaReceber.refresh();
        this.$bvModal.hide("menuAcoes");
        this.$bvModal.hide("gerarCarneBoleto");
      } catch (error) {
        this.$bvModal.hide("gerarCarneBoleto");
      }
      this.removeLoadingToButton("gerarCarneBoleto");
    },
    async gerarCarne() {
      this.addLoadingToButton("gerarCarne");
      try {
        await this.$http
          .post("/contareceber/carne", {
            contas_receber: this.actionsStore.selectedRows.map((conta) => ({
              id: conta.id,
            })),
          })
          .then((result) => {
            if (result["data"]["carne"]) {
              this.actionsStore.selectedRows = [];
              this.actionsStore.updateTable = !this.actionsStore.updateTable;
              this.$toast.success("Carnê gerado com sucesso!");
              this.$refs.contaReceber.refresh();
              this.$bvModal.hide("menuAcoes");
              this.$bvModal.hide("gerarCarne");
              window.open(result["data"]["carne"], "_blank");
            }
            swal.stopLoading();
            swal.close();
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
        this.actionsStore.selectedRows = [];
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Carnê gerado com sucesso!");
        this.$refs.contaReceber.refresh();
        this.$bvModal.hide("menuAcoes");
        this.$bvModal.hide("gerarCarne");
      } catch (error) {
        this.$bvModal.hide("gerarCarne");
      }
      this.removeLoadingToButton("gerarCarne");
    },
    async gerarCarneLoja() {
      this.addLoadingToButton("gerarCarneLoja");
      try {
        await this.$http
          .post("/contareceber/carne-loja", {
            contas_receber: this.actionsStore.selectedRows.map((conta) => ({
              id: conta.id,
            })),
          })
          .then((result) => {
            if (result["data"]["carne"]) {
              this.actionsStore.selectedRows = [];
              this.actionsStore.updateTable = !this.actionsStore.updateTable;
              this.$toast.success("Carnê gerado com sucesso!");
              this.$refs.contaReceber.refresh();
              this.$bvModal.hide("menuAcoes");
              this.$bvModal.hide("gerarCarneLoja");
              window.open(result["data"]["carne"], "_blank");
            }
            swal.stopLoading();
            swal.close();
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
        this.actionsStore.selectedRows = [];
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Carnê gerado com sucesso!");
        this.$refs.contaReceber.refresh();
        this.$bvModal.hide("menuAcoes");
        this.$bvModal.hide("gerarCarneLoja");
      } catch (error) {
        this.$bvModal.hide("gerarCarneLoja");
      }
      this.removeLoadingToButton("gerarCarneLoja");
    },
    async gerarRecibo(tipo = "individual") {
      const selecionadas = this.actionsStore.selectedRows || [];
      const isMultiplo = selecionadas.length > 1;
      const refLoading = isMultiplo
        ? tipo === "unificado"
          ? "gerarReciboUnificado"
          : "gerarRecibosIndividuais"
        : "gerarRecibo";

      this.addLoadingToButton(refLoading);
      try {
        const result = isMultiplo
          ? await this.$http.post("/contareceber/recibos", {
              tipo,
              contas_receber: selecionadas.map((conta) => ({
                id: conta.id,
              })),
            })
          : await this.$http.post("/contareceber/recibo", {
              id_conta_receber: selecionadas[0]?.id,
            });

        if (result["data"]["url_recibo"]) {
          window.open(result["data"]["url_recibo"], "_blank");
        }

        if (result["data"]["urls_recibos"]) {
          result["data"]["urls_recibos"].forEach((url) => {
            window.open(url, "_blank");
          });
        }

        this.actionsStore.selectedRows = [];
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success(
          isMultiplo
            ? "Recibos gerados com sucesso!"
            : "Recibo gerado com sucesso!"
        );
        this.$refs.contaReceber.refresh();
        this.$bvModal.hide("menuAcoes");
        this.$bvModal.hide("gerarRecibo");
      } catch (error) {
        const mensagem =
          error?.response?.data?.msg || "Não foi possível gerar o recibo.";
        this.$toast.error(mensagem);
        this.$bvModal.hide("gerarRecibo");
      }
      this.removeLoadingToButton(refLoading);
    },
    async marcar() {
      this.addLoadingToButton("marcarContas");
      try {
        await this.$http.post("/contareceber/marcar", {
          contas_receber: this.actionsStore.selectedRows.map((conta) => ({
            id: conta.id,
          })),
        });
        this.actionsStore.selectedRows = [];
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Contas marcadas com sucesso!");
        this.$refs.contaReceber.refresh();
        this.$bvModal.hide("menuAcoes");
        this.$bvModal.hide("marcarContas");
      } catch (error) {
        this.$bvModal.hide("marcarContas");
      }
      this.removeLoadingToButton("marcarContas");
    },
    async inativarConta() {
      this.addLoadingToButton("inativarConta");
      try {
        await this.$http.post("/contareceber/inativar", {
          contas_receber: this.actionsStore.selectedRows.map((conta) => ({
            id: conta.id,
          })),
        });
        this.actionsStore.selectedRows = [];
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Contas inativadas com sucesso!");
        this.$refs.contaReceber.refresh();
        this.$bvModal.hide("menuAcoes");
        this.$bvModal.hide("inativarContas");
      } catch (error) {
        this.$bvModal.hide("inativarContas");
      }
      this.removeLoadingToButton("inativarConta");
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked", "nutsDigital"]),
    ...mapState({
      currentUser: (state) => state.auth.user,
    }),
    config() {
      return this.layoutConfig();
    },
    hasPeriodFilter() {
      return Boolean(
        filtersStore.contasReceber.filters.range_data_vencimento?.length
      );
    },
    periodFilterLabel() {
      return this.hasPeriodFilter
        ? filtersStore.filterOptionSelected.label
        : "Período";
    },
    parcialValueToDisplay() {
      if (actionsStore.selectedRows.length === 0) {
        return 0;
      }
      if (actionsStore.selectedRows[0].valor_total > 0) {
        return parseFloat(actionsStore.selectedRows[0].valor_total);
      }
      return parseFloat(actionsStore.selectedRows[0].valor);
    },
    recebimentoTableItems() {
      if (actionsStore.selectedRows.length === 0) return [];
      return actionsStore.selectedRows
        .filter((row) => this.isContaDisponivelParaRecebimento(row))
        .map((row) => {
          const valor = parseFloat(row.valor || 0);
          const juros = parseFloat(row.juros || 0);
          const multa = parseFloat(row.multa || 0);
          const desconto = parseFloat(row.desconto || 0);
          const descontoRateado = parseFloat(row._descontoRateado || 0);
          const valorLiquido =
            valor + juros + multa - desconto - descontoRateado;

          return {
            documento: row.documento,
            cliente: row.cliente,
            vencimento: row.data_vencimento,
            recebimento: row.data_recebimento,
            valor: this.numberToReal(valor, 2),
            juros: this.numberToReal(juros, 2),
            multa: this.numberToReal(multa, 2),
            desconto: this.numberToReal(desconto + descontoRateado, 2),
            valor_total: this.numberToReal(Math.max(valorLiquido, 0), 2),
            status: this.onRowStatus(row, true),
          };
        });
    },
    agrupamentoTableItems() {
      if (actionsStore.selectedRows.length === 0) return [];
      return actionsStore.selectedRows
        .map((row) => {
          const valor = parseFloat(row.valor || 0);
          const juros = parseFloat(row.juros || 0);
          const multa = parseFloat(row.multa || 0);
          const desconto = parseFloat(row.desconto || 0);
          const valorTotal =
            parseFloat(row.valor_total || 0) > 0
              ? parseFloat(row.valor_total || 0)
              : valor + juros + multa - desconto;

          return {
            documento: row.documento,
            cliente: row.cliente,
            vencimento: row.data_vencimento,
            recebimento: row.data_recebimento,
            valor: this.numberToReal(valor, 2),
            juros: this.numberToReal(juros, 2),
            multa: this.numberToReal(multa, 2),
            desconto: this.numberToReal(desconto, 2),
            valor_total: this.numberToReal(Math.max(valorTotal, 0), 2),
            status: this.onRowStatus(row, true),
          };
        })
        .filter((item) => item.status !== "Recebida");
    },
    totalRecebimento() {
      if (actionsStore.selectedRows.length === 0) return 0;
      return actionsStore.selectedRows
        .filter((row) => this.isContaDisponivelParaRecebimento(row))
        .reduce((acc, row) => {
          const valor = parseFloat(row.valor || 0);
          const juros = parseFloat(row.juros || 0);
          const multa = parseFloat(row.multa || 0);
          const desconto = parseFloat(row.desconto || 0);
          const descontoRateado = parseFloat(row._descontoRateado || 0);
          return acc + valor + juros + multa - desconto - descontoRateado;
        }, 0);
    },
    totalAgrupamento() {
      if (actionsStore.selectedRows.length === 0) return 0;
      const descontoAgrupamento = this._unmaskMoney(this.descontoAgrupamento);

      return Math.max(this.totalAgrupamentoBruto - descontoAgrupamento, 0);
    },
    totalAgrupamentoBruto() {
      if (actionsStore.selectedRows.length === 0) return 0;
      return actionsStore.selectedRows.reduce((acc, row) => {
        const valorTotal = parseFloat(row.valor_total || 0);

        if (valorTotal > 0) {
          return acc + valorTotal;
        }

        const valor = parseFloat(row.valor || 0);
        const juros = parseFloat(row.juros || 0);
        const multa = parseFloat(row.multa || 0);
        const desconto = parseFloat(row.desconto || 0);

        return acc + valor + juros + multa - desconto;
      }, 0);
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
    this.verificaContasReceber();
  },
};
</script>

<style>
.flatpickr-months .flatpickr-month,
.flatpickr-current-month .flatpickr-monthDropdown-months,
.flatpickr-weekdays,
span.flatpickr-weekday {
  background: var(--primary-color) !important;
}
.flatpickr-calendar.arrowTop:before {
  border-bottom-color: var(--primary-color) !important;
  color: var(--primary-color) !important;
}
#menuAcoes___BV_modal_footer_ {
  display: flex;
  justify-content: space-between;
}
#agruparContas___BV_modal_footer_ {
  display: flex;
  justify-content: space-between;
}
.inativa-link {
  text-decoration: line-through;
}
.agrupamento-info {
  align-items: center;
  background: #181c32;
  border-radius: 50%;
  color: #ffffff;
  display: inline-flex;
  font-size: 10px;
  font-weight: 700;
  height: 16px;
  justify-content: center;
  line-height: 16px;
  width: 16px;
}
</style>
